export const cutString = (limit, text) => {
    let newContent
    if (
        text &&
        limit &&
        typeof text === 'string' &&
        text.length > limit
    ) {
        newContent = `${text.slice(0, limit)}...` 
    } else {
        newContent = text
    }
    return newContent;
}